export const currencies = { USD: "$", EUR: "€", CZK: "Kč", GBP: "£", HKD: "HK$", CNY: "¥" };
